import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedirectFormService } from '../services/redirect-form.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'redirect-page',
  templateUrl: './redirect-page.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class RedirectPageComponent implements OnInit {
  key: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private redirectService: RedirectFormService,
    private alert: ToastrService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.key = params.get('key');
      if (this.key) {
        this.fetchData(this.key);
      } else {
        this.alert.error("Invalid request");
      }
    });
  }

  fetchData(key: string) {
    this.redirectService.getRedirectUrl(key).subscribe(
      ({ fullUrl }) => {
        window.location.href = fullUrl;
      },
      (error) => {
        console.error('API Error:', error);
        this.alert.error("Error while processing your request");
      }
    );
  }
}